import { ChangeDetectionStrategy, Component, Injector } from '@angular/core';
import { InvoiceStatus } from '@ducat-pro-anapi/swag-anapi-v2';
import { provideValueAccessor } from '@s-libs/ng-core';

import { FilterSuperclass } from '@dsh/components/filter';

@Component({
    selector: 'dsh-invoice-status-filter',
    templateUrl: 'invoice-status-filter.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [provideValueAccessor(InvoiceStatusFilterComponent)],
})
export class InvoiceStatusFilterComponent extends FilterSuperclass<InvoiceStatus.StatusEnum> {
    constructor(injector: Injector) {
        super(injector);
    }
}
